import React from 'react';
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (process.env.REACT_APP_BUILD_TARGET === 'ess') {
    import('./EmployeePortal').then(({ default: EmployeePortal }) => {
        root.render(<EmployeePortal />);
    });
} else {
    import('./App').then(({ default: App }) => {
        root.render(<App />);
    });
}
